import { useQuery } from '@tanstack/react-query'

import { useCurrentUser } from '@/api/auth/queries/useCurrentUser'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { getPackageReqs } from '../packageReqService'

interface Props {
  warehouse?: string
  userId?: string
  onlyPending?: boolean
}
export const usePackageReqs = ({ warehouse, userId, onlyPending = true }: Props = {}) => {
  const { data: loggedUser } = useCurrentUser()
  const userWarehouse = loggedUser?.permissions['Admin'] ? '' : loggedUser?.UserAttributes['custom:warehouse']
  const warehouseToUse = warehouse ?? userWarehouse
  const queryKey = [QUERY_KEYS.PACKAGE_REQUESTS, warehouseToUse, userId, onlyPending].filter(k => k !== undefined) as string[]

  return useQuery({
    queryKey,
    queryFn: () => getPackageReqs({ warehouse: warehouseToUse, onlyPending, userId }),
  })
}
